import React, { memo, PropsWithChildren, useCallback } from "react";

import { Text, HStack, Button } from "@chakra-ui/react";
import { useAuth } from "modules/providers/auth-provider";
import colors from "app/colors";
import moment from "moment";
import { FileMessageIcon } from "modules/icons";
import { useRouter } from "next/router";
import { useOverlay } from "modules/providers/overlay-provider";
import {
  MESSAGE_ID_QUERY_STRING,
  MESSAGE_THREAD_ID_QUERY_STRING,
  TIMESTAMP_QUERY_STRING,
} from "modules/hooks/use-query-string";

interface IProps extends PropsWithChildren {
  messageThreadId?: string | null;
  messageId?: string | null;
  isVoiceNote?: boolean;
}

const MessageLink = ({
  messageThreadId,
  messageId,
  isVoiceNote = false,
}: IProps) => {
  const { me } = useAuth();
  const { push, query } = useRouter();
  const { closeDrawer } = useOverlay();

  const onNavigateToMessageClicked = useCallback(
    () => () => {
      closeDrawer();
      push({
        query: {
          ...query,
          [MESSAGE_THREAD_ID_QUERY_STRING]: messageThreadId,
          [MESSAGE_ID_QUERY_STRING]: messageId,
          [TIMESTAMP_QUERY_STRING]: moment().unix(),
        },
      });
    },
    [closeDrawer, messageId, messageThreadId, push, query],
  );

  if (!me || !messageThreadId || !messageId) return null;

  return (
    <Button
      onClick={onNavigateToMessageClicked()}
      leftIcon={<FileMessageIcon fill={colors.blue} boxSize={4} />}
      variant="hover"
      size="xxs"
    >
      <HStack spacing={0.5}>
        <Text fontSize={14} fontWeight={500} color={colors.blue}>
          {`View Message${isVoiceNote ? "/Transcription" : ""}`}
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessageLink);
